import i18next from "i18next";
import { ToastOptions, toast } from "react-toastify";

export const generateLoadingToast = (msg: string = null) => {
  const toastId = Math.random();
  const message = i18next.t("obd_notifications.awaiting_wallet_signature");
  const toastOptions: ToastOptions = {
    className: "custom-toast",
    hideProgressBar: false,
    toastId: toastId,
    closeButton: true
  };
  toast.loading(msg ?? message, toastOptions);
  // setTimeout(() => toast.update(toastId, getUpdatedToastOptions("error", "Oops, something went wrong")), 60000);
  return toastId;
}

export const getUpdatedToastOptions = (type: "error" | "success", msg: string) => {
  return {
    type,
    render: msg, 
    isLoading: false, 
    autoClose: 3000
  }
}